import { render } from "./SkillLogo.vue?vue&type=template&id=3319c824&ts=true"
import script from "./SkillLogo.vue?vue&type=script&lang=ts"
export * from "./SkillLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__